import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import Error from '../components/Error';
import Loader from '../components/Loader';
import RelatedBlogs from '../components/RelatedBlogs';
import SingleBlog from '../components/SingleBlog';
import { fetchBlog } from '../features/blog/blogSlice';

const SingleBlogPage = () => {
  const dispatch = useDispatch();
  const { blogId } = useParams();

  const { blog, isLoading, isError, error } = useSelector(
    (state) => state.blog
  );

  const { id, tags } = blog;

  useEffect(() => {
    dispatch(fetchBlog(blogId));
  }, [dispatch, blogId]);

  // decide what to render
  let content = null;

  if (isLoading) content = <Loader />;

  if (!isLoading && isError) content = <Error msg={error} />;

  if (!isError && !isLoading && !blog?.id) {
    content = <div className="col-span-12">No Blog Found!</div>;
  }

  if (!isError && !isLoading && blog?.id) {
    content = (
      <>
        <SingleBlog blog={blog} />
        <RelatedBlogs id={id} tags={tags} />
      </>
    );
  }

  return (
    <>
      <div className="container mt-8">
        <Link
          to="/"
          className="inline-block text-gray-600 home-btn"
          id="lws-goHome"
        >
          <i className="mr-2 fa-solid fa-house"></i>Go Home
        </Link>
      </div>
      <section className="post-page-container">{content}</section>
    </>
  );
};

export default SingleBlogPage;
